import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadMaterialsQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadMaterialsQuery = (
  { __typename?: 'Query' }
  & { materials: Array<(
    { __typename?: 'Material' }
    & Pick<Types.Material, '_id' | '_deleted' | 'containerType' | 'label' | 'nettoWeight' | 'length' | 'width' | 'height' | 'inactive'>
  )> }
);

export type CreateMaterialMutationVariables = {
  input?: Types.Maybe<Types.MaterialInsertType>
};


export type CreateMaterialMutation = (
  { __typename?: 'Mutation' }
  & { createMaterial: (
    { __typename?: 'Material' }
    & Pick<Types.Material, '_id'>
  ) }
);

export type UpdateMaterialMutationVariables = {
  id?: Types.Maybe<Types.Scalars['ID']>,
  update?: Types.Maybe<Types.MaterialSetType>
};


export type UpdateMaterialMutation = (
  { __typename?: 'Mutation' }
  & { updateMaterial: Array<(
    { __typename?: 'Material' }
    & Pick<Types.Material, '_id'>
  )> }
);

export type DeleteMaterialMutationVariables = {
  ids: Array<Types.Scalars['ID']>
};


export type DeleteMaterialMutation = (
  { __typename?: 'Mutation' }
  & { deleteMaterial: Array<(
    { __typename?: 'Material' }
    & Pick<Types.Material, '_deleted'>
  )> }
);

export const ReadMaterialsDocument = gql`
    query ReadMaterials($search: String) {
  materials(filter: {label: {REGEX: $search, OPTIONS: "i"}}, sort: {label: ASC}) {
    _id
    _deleted
    containerType
    label
    nettoWeight
    length
    width
    height
    inactive
  }
}
    `;

    export function useReadMaterialsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadMaterialsQuery, ReadMaterialsQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadMaterialsQuery, ReadMaterialsQueryVariables>(ReadMaterialsDocument, baseOptions);
    };
      export function useReadMaterialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadMaterialsQuery, ReadMaterialsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadMaterialsQuery, ReadMaterialsQueryVariables>(ReadMaterialsDocument, baseOptions);
      };
      
export type ReadMaterialsQueryHookResult = ReturnType<typeof useReadMaterialsQuery>;
export type ReadMaterialsQueryResult = ApolloReactCommon.QueryResult<ReadMaterialsQuery, ReadMaterialsQueryVariables>;
export const CreateMaterialDocument = gql`
    mutation CreateMaterial($input: MaterialInsertType) {
  createMaterial(input: $input) {
    _id
  }
}
    `;
export type CreateMaterialMutationFn = ApolloReactCommon.MutationFunction<CreateMaterialMutation, CreateMaterialMutationVariables>;

    export function useCreateMaterialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMaterialMutation, CreateMaterialMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateMaterialMutation, CreateMaterialMutationVariables>(CreateMaterialDocument, baseOptions);
    };
export type CreateMaterialMutationHookResult = ReturnType<typeof useCreateMaterialMutation>;
export type CreateMaterialMutationResult = ApolloReactCommon.MutationResult<CreateMaterialMutation>;
export type CreateMaterialMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateMaterialMutation, CreateMaterialMutationVariables>;
export const UpdateMaterialDocument = gql`
    mutation UpdateMaterial($id: ID, $update: MaterialSetType) {
  updateMaterial(filter: {_id: {EQ: $id}}, update: {set: $update}) {
    _id
  }
}
    `;
export type UpdateMaterialMutationFn = ApolloReactCommon.MutationFunction<UpdateMaterialMutation, UpdateMaterialMutationVariables>;

    export function useUpdateMaterialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMaterialMutation, UpdateMaterialMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateMaterialMutation, UpdateMaterialMutationVariables>(UpdateMaterialDocument, baseOptions);
    };
export type UpdateMaterialMutationHookResult = ReturnType<typeof useUpdateMaterialMutation>;
export type UpdateMaterialMutationResult = ApolloReactCommon.MutationResult<UpdateMaterialMutation>;
export type UpdateMaterialMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMaterialMutation, UpdateMaterialMutationVariables>;
export const DeleteMaterialDocument = gql`
    mutation DeleteMaterial($ids: [ID!]!) {
  deleteMaterial(filter: {_id: {IN: $ids}}) {
    _deleted
  }
}
    `;
export type DeleteMaterialMutationFn = ApolloReactCommon.MutationFunction<DeleteMaterialMutation, DeleteMaterialMutationVariables>;

    export function useDeleteMaterialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMaterialMutation, DeleteMaterialMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteMaterialMutation, DeleteMaterialMutationVariables>(DeleteMaterialDocument, baseOptions);
    };
export type DeleteMaterialMutationHookResult = ReturnType<typeof useDeleteMaterialMutation>;
export type DeleteMaterialMutationResult = ApolloReactCommon.MutationResult<DeleteMaterialMutation>;
export type DeleteMaterialMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteMaterialMutation, DeleteMaterialMutationVariables>;